import Vue from 'vue';
import Vuex from 'vuex';
// import tp from "tp-js-sdk";
import { CHG_MAP } from "../utils";
import { TP_SERVER_DOMAIN } from "../utils/config";

Vue.use(Vuex);

// let theme = localStorage.getItem('theme');
// let mode = false;
// console.log('store', theme);

// // 如果已经设置过暗黑模式
// const isDarkTheme = window.matchMedia('(prefers-color-scheme: dark)'); // 是深色
// console.log('isDarkTheme', isDarkTheme);
// if (theme) {
//   if (theme === 'auto' && isDarkTheme) {
//     if (isDarkTheme.matches) {
//       // 主题设置为深色。
//       mode = true;
//     } else {
//       // 主题设置为浅色。
//       mode = false;
//     }
//   } else if (theme == 'dark') {
//     mode = true;
//   } else {
//     mode = false;
//   }
//   setMode(mode)
// } else {
//   if (navigator.userAgent.indexOf('TokenPocket') === -1) {
//     if (isDarkTheme.matches) {
//       // 主题设置为深色。
//       mode = true;
//     } else {
//       // 主题设置为浅色。
//       mode = false;
//     }
//     setMode(mode)
//   } else {
//     tp.isDarkMode().then(res => {
//       console.log('tp', res);
//       if (res && res.data) {
//         mode = true
//       } else {
//         mode = false
//       }
//       setMode(mode)
//     })
//   }
// }

// if (mode) {
//   document.documentElement.setAttribute('theme', 'dark');
//   console.log('isDarkMode', mode);
//   // localStorage.setItem('theme', 'dark')
// } else {
//   document.documentElement.removeAttribute('theme');
//   // localStorage.setItem('theme', 'light')
// }

export default new Vuex.Store({
  state: {
    isDarkMode: false,
    isMobileSize: false,
    isAppSettingDialog: false,
    blockchainList: [],
    utc_type: '',
    deviceSize: '',
  },
  mutations: {
    setDeviceSize(state, payload) {
      state.deviceSize = payload;
    },
    setDarkMode(state, payload) {
      state.isDarkMode = payload;
    },
    setMobileSize(state, payload) {
      state.isMobileSize = payload;
    },
    setAppSettingDialog(state, payload) {
      state.isAppSettingDialog = payload;
    },
    setBlockchainList(state, payload) {
      state.blockchainList = payload
    },
    setUTCType(state, payload) {
      state.utc_type = payload;
    }
  },
  actions: {
    async SET_BLOCK_CHAIN_LIST({ commit }, payload) {
      // console.log('SET_BLOCK_CHAIN_LIST');
      try {
        const response = await fetch(
          `${TP_SERVER_DOMAIN}/v1/block_chain/list?lang=${payload}&version=0.0.1&os=web`
        );
        const res = await response.json();
        if (res.result === 0 && res.data) {
          let list = res.data.map((item) => {
            let anti_mev = ''
            if (item.metadata) {
              anti_mev = JSON.parse(item.metadata).anti_mev
            }
            const { hid, title, icon_url } = item
            return { hid, title, icon: icon_url, anti_mev, ns: item.ns };
          });
          localStorage.setItem('blockchainList', JSON.stringify(list))
          commit('setBlockchainList', list)
        }
      } catch (error) {
        // todo 如果获取不到 本地也没有 是否需要处理  blockchainList
        let blockchainList = JSON.parse(localStorage.getItem('blockchainList')) || [];
        commit('setBlockchainList', blockchainList)
        console.log(error);
      }
    },
  },
  getters: {
    utc_type(state) {
      return state.utc_type
    },
    deviceSize(state) {
      return state.deviceSize
    },
    currentUTC(state) {
      return CHG_MAP[state.utc_type] || '24h'
    },
    isDarkMode(state) {
      return state.isDarkMode;
    },
    isMobileSize(state) {
      return state.isMobileSize;
    },
    isAppSettingDialog(state) {
      return state.isAppSettingDialog;
    },
    blockchainList(state) {
      return state.blockchainList;
    },
  },
  modules: {},
});
